import React from 'react';
import { useUser } from '@sde/widgets-core/src/redux/resources/user';
import { useOnboarding } from '@sde/widgets-core/src/redux/resources/onboarding';
import { styled } from '@uhg-abyss/web/tools/styled';
import { useModal } from 'src/state/modal';
import { NavMenuPrimitives } from '@uhg-abyss/web/ui/NavMenu';
import PropTypes from 'prop-types';

const StyledCell = styled(NavMenuPrimitives.MenuItem, {
  '& .abyss-nav-menu-link': {
    width: '100%',
    alignItems: 'flex-start',
    justifyContent: 'center',
    padding: '4px 8px',
    '&:hover': {
      backgroundColor: '$gray2',
      width: '100%',
      '&:before': {
        width: 0,
      },
    },
  },
  dynamic: ({ isDisabled }) => {
    return {
      color: !isDisabled ? '$interactive1' : '$gray5',
      '&:hover': {
        backgroundColor: !isDisabled && '$gray2',
        color: !isDisabled ? '$interactive1' : '$gray5',
      },
    };
  },
});

const NavMenuPrimitivesMenuItem = ({
  datatestid,
  title,
  onClick,
  isDisabled,
}) => {
  return (
    <div data-testId={datatestid} data-cy={datatestid}>
      <StyledCell title={title} onClick={onClick} isDisabled={isDisabled} />
    </div>
  );
};

export const ReactivateTrainingTipsNew = () => {
  const { user } = useUser.state();
  const { tooltips } = useOnboarding.state();
  const isDisabled = Object.values(tooltips).every((isActive) => isActive);
  const { toggleModal } = useModal.actions();

  const openReactivateTrainingTipModal = () => {
    toggleModal({
      key: 'training-modal',
      isOpen: true,
    });
  };

  if (Object.values(tooltips).length === 0) {
    return null;
  }

  return (
    <NavMenuPrimitivesMenuItem
      datatestid="reactivate-training-tips"
      title="Reactivate Training Tips"
      onClick={openReactivateTrainingTipModal}
      isDisabled={user.isTechnicalUser || isDisabled}
    />
  );
};

NavMenuPrimitivesMenuItem.propTypes = {
  datatestid: PropTypes.string,
  title: PropTypes.string,
  onClick: PropTypes.func,
  isDisabled: PropTypes.bool,
};

NavMenuPrimitivesMenuItem.defaultProps = {
  datatestid: null,
  title: null,
  onClick: () => {},
  isDisabled: false,
};
